import { StrictMode } from "react"

import { QueryClientProvider } from "@tanstack/react-query"

import { IDirective } from "angular"
import { createRoot } from "react-dom/client"

import { queryClient } from "@/query/queryClient"

import OrderController from "../../app/controllers/order/order.controller"
import { PricingPage } from "./PricingPage"

export function PricingPageDirective(): IDirective {
  return {
    restrict: "E",
    controller: "OrderController",
    link: function (scope, element, _attributes, controller) {
      const root = createRoot(element[0])
      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <PricingPage controller={controller as OrderController} />
          </QueryClientProvider>
        </StrictMode>,
      )

      // Clean up React component when the Angular component is destroyed
      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
  }
}
